const TYPES = {
    GET_APP_CONFIG: 'GET_APP_CONFIG',
    GET_APP_CONFIG_COMPLETE: 'GET_APP_CONFIG_COMPLETE',
    GET_APP_CONFIG_FAILED: 'GET_APP_CONFIG_FAILED',
    SET_APP_CONFIG_FG_ONBOARDING: 'SET_APP_CONFIG_FG_ONBOARDING',
    SET_APP_CONFIG_FG_ONBOARDING_COMPLETE: 'SET_APP_CONFIG_FG_ONBOARDING_COMPLETE',
    SET_APP_CONFIG_FG_ONBOARDING_FAILED: 'SET_APP_CONFIG_FG_ONBOARDING_FAILED',
    SET_TIME_RANGE_WARNING_STATE: 'SET_TIME_RANGE_WARNING_STATE',
    SET_TIME_RANGE_WARNING_STATE_COMPLETE: 'SET_TIME_RANGE_WARNING_STATE_COMPLETE',
    SET_TIME_RANGE_WARNING_STATE_FAILED: 'SET_TIME_RANGE_WARNING_STATE_FAILED'
};

export default {
    TYPES,

    getAppConfig: (payload?) => ({
        type: TYPES.GET_APP_CONFIG,
        payload
    }),

    getAppConfigSuccess: (config?) => ({
        type: TYPES.GET_APP_CONFIG_COMPLETE,
        payload: config
    }),

    getAppConfigFailed: (error?) => ({
        type: TYPES.GET_APP_CONFIG_FAILED,
        payload: {error}
    }),

    setAppConfigFGOnboarding: (payload?) => ({
        type: TYPES.SET_APP_CONFIG_FG_ONBOARDING,
        payload
    }),

    setAppConfigFGOnboardingSuccess: (payload?) => ({
        type: TYPES.SET_APP_CONFIG_FG_ONBOARDING_COMPLETE,
        payload
    }),

    setAppConfigFGOnboardingFailed: (error?) => ({
        type: TYPES.SET_APP_CONFIG_FG_ONBOARDING_FAILED,
        payload: {error}
    }),

    setTimeRangeWarningState: (payload?) => ({
        type: TYPES.SET_TIME_RANGE_WARNING_STATE,
        payload
    }),

    setTimeRangeWarningStateSuccess: (payload?) => ({
        type: TYPES.SET_TIME_RANGE_WARNING_STATE_COMPLETE,
        payload
    }),

    setTimeRangeWarningStateFailed: (error?) => ({
        type: TYPES.SET_TIME_RANGE_WARNING_STATE_FAILED,
        payload: {error}
    })
};
